// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1229":"304f678f","5071":"5fdb438f","9213":"5fdb438f"}[chunkId] + ".chunk.css";
};